import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './Login.css';
import backgroundImage from '../../Assets/Loginbackground.png';
import { API_BASE_URL } from '../../config';
//console.log('API response:', response.data);

export default function LoginForm() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.password) newErrors.password = 'Password is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/Login.php`, formData);

      if (response.data.status) {
        const { user_name, user_role, user_id } = response.data;

        // Save user info in localStorage
        localStorage.setItem('userName', user_name);
        localStorage.setItem('userRole', user_role);
        localStorage.setItem('userID', user_id);

        alert(`Welcome ${user_name}!`);
        navigate('/dashboard');
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error(error);
      alert('There was an error submitting the form. Please try again.');
    }
  };

  const handleSignupRedirect = () => navigate('/signup');
  const handleForgotPassword = () => navigate('/forgotpassword');

  return (
    <div className="container-split">
      <div
        className="image-half"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      <div className="form-half">
        <div className="access-container1">
          <h2 className="access-title">Log In</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter Email"
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter Password"
                isInvalid={!!errors.password}
              />
              <Form.Control.Feedback type="invalid">
                {errors.password}
              </Form.Control.Feedback>
            </Form.Group>

            <Button variant="primary" type="submit" className="button1">
              Sign In
            </Button>
          </Form>

          <div className="bottom mt-3">
            <p className="account">
              Don't have an Account?{' '}
              <Button variant="link" onClick={handleSignupRedirect}>
                Sign Up Here
              </Button>
            </p>

            <p>
              <Button variant="link" onClick={handleForgotPassword}>
                Forgot Password?
              </Button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
